if (!customElements.get('pp-terrarium-catalog')) {
  customElements.define('pp-terrarium-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const cards = [...this.querySelectorAll('[data-td-card]')];
      const filters = this.querySelector('[data-td-filters]');
      const count = this.querySelector('[data-td-count]');
      const empty = this.querySelector('[data-td-empty]');
      if (filters) {
        filters.hidden = false;
        filters.addEventListener('click', event => {
          const button = event.target.closest('[data-td-filter]');
          if (!button) return;
          const filter = button.dataset.tdFilter;
          let visible = 0;
          cards.forEach(card => {
            const match = filter === 'all' || card.dataset.group === filter || card.dataset.size === filter;
            card.hidden = !match;
            if (match) visible++;
          });
          filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
          count.textContent = `${visible} ${count.dataset.countLabel}`;
          empty.hidden = visible > 0;
        });
      }
      this.querySelector('[data-td-sort]')?.addEventListener('change', event => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', event.target.value);
        url.searchParams.delete('page');
        window.location.assign(url);
      });
    }
  });
}

if (!customElements.get('td-review-video')) {
  customElements.define('td-review-video', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const start = this.querySelector('button');
      const template = this.querySelector('template');
      if (!start || !template) return;
      start.hidden = false;
      start.addEventListener('click', () => {
        if (!this.video) {
          this.append(template.content.cloneNode(true));
          this.video = this.querySelector('video');
          this.video.setAttribute('tabindex', '0');
          this.video.addEventListener('play', () => {
            document.querySelectorAll('#MainContent video').forEach(video => {
              if (video !== this.video) video.pause();
            });
          }, options);
          this.video.addEventListener('error', () => {
            this.video.hidden = true;
            start.hidden = false;
          }, options);
        }
        start.hidden = true;
        this.video.hidden = false;
        this.video.focus();
        this.video.play().catch(() => {
          start.hidden = false;
          this.video.hidden = true;
        });
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video?.pause();
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (!entries[0].isIntersecting) this.video?.pause();
        });
        this.observer.observe(this);
      }
    }
    disconnectedCallback() {
      this.video?.pause();
      this.video?.remove();
      this.video = null;
      this.observer?.disconnect();
      this.events?.abort();
      this.events = null;
    }
  });
}
